import { env } from '@/env';
import { useSfidaDiPiattaforma } from '@/hooks/useSfidaDiPiattaforma';

/**
 * Il tab «Sfide» esiste con QDuels acceso (com'era) O sotto la serratura di piattaforma (Limulo + beta, B2). Fuori serratura `piattaforma` e' la costante `false` e `mostraSfide` e'
 * `env.featureQduelsEnabled`: il tab e' quello di oggi. UNA definizione, per Amici e per la v3: la chiave SFIDE c'e' quando oggi c'e' il tab.
 */
export function useMostraSfide(): { piattaforma: boolean; mostraSfide: boolean } {
  const piattaforma = useSfidaDiPiattaforma();
  return { piattaforma, mostraSfide: env.featureQduelsEnabled || piattaforma };
}
